import React from "react";
import { Link } from "react-router-dom";
import {utils,writeFileXLSX} from 'xlsx';

import {ChangeDateStringOnlyDate,clearCheckedLists, unescapeHtml} from "../../../components/common/Common";

function StaffReportSearchResult({varMaxNumPage,varStaffReportLists,setStaffReportLists}) {

  //목록의 모든 항목 선택하기
  const onCheckedAll = (e) => {
    const bChecked = Number(e.currentTarget.checked);
    clearCheckedLists(bChecked);
    //배열값 변경
    let copyDatas = [...varStaffReportLists];
    for (var i=0; i < copyDatas.length; i++) {
      copyDatas[i].checked = bChecked;
    }
    setStaffReportLists(copyDatas);
  } 

  //목록상의 항목 선택하기
  const onCheckedElement = (e,sr_idx) => {
    const bChecked = Number(e.currentTarget.checked);
    const findIndex = varStaffReportLists.findIndex(element=>element.sr_idx===sr_idx);
    let copyLists = [...varStaffReportLists];
    copyLists[findIndex].checked = bChecked;
    setStaffReportLists(copyLists);
    CheckAllButtonState();
  }

  const CheckAllButtonState = () => {
    //전체버튼 점검
    let bchecked = true;
    const delItems = document.querySelectorAll('.del-item');
    for(var i=0; i < delItems.length; i++) {
      if(delItems[i].checked === false) {
        bchecked = false;
        break;
      }
    }
    const chkallItem = document.getElementById('deleteItems');
    chkallItem.checked = bchecked;
  } 

  //엑셀 다운로드
  const onDownloadExcelHandler = (e) => {
    let titleArray = {번호:'',등록일자:'',아이디:'',작성자:'',소속:'',직위:'',업무요약:''}; 
    const dataArray = varStaffReportLists.filter(el=>el.checked === 1);
    if(dataArray?.length === 0) {
      alert('엑셀파일로 만들 항목들을 먼저 선택하세요.'); return false;
    }
    if(!window.confirm('Excel 파일로 다운로드합니까?')) return false;
    let excelList = [];
    for(var i=0; i < dataArray.length; i++) {
      var lineObj = dataArray[i];
      var newExcelObj = {...titleArray};
      newExcelObj['번호'] = varMaxNumPage - i;
      newExcelObj['등록일자'] = ChangeDateStringOnlyDate(lineObj.sr_date);
      newExcelObj['아이디'] = lineObj.mem_id;
      newExcelObj['작성자'] = lineObj.mem_name;
      newExcelObj['소속'] = lineObj.vd_name;
      newExcelObj['직위'] = lineObj.vp_name;
      newExcelObj['업무요약'] = unescapeHtml(lineObj.sr_summary);
      excelList.push(newExcelObj);
    }

    const ws = utils.json_to_sheet(excelList);
    const wb = utils.book_new();
    utils.book_append_sheet(wb,ws,'업무일지현황');
    writeFileXLSX(wb,'더나은물류-업무일지관리.xlsx');
    clearCheckedLists(false);
  }

  return (
    <>
      <div className="main-box" style={{marginTop:"30px"}}>
        <div className="btn-right">
          <button onClick={(e)=>onDownloadExcelHandler(e)} className="btn line">EXCEL 다운로드</button>
        </div>
        <table className="list">
          <colgroup>
            <col style={{width:"5%"}} />
            <col style={{width:"5%"}} />
            <col style={{width:"15%"}} />
            <col style={{width:"10%"}} />
            <col style={{width:"10%"}} />
            <col style={{width:"15%"}} />
            <col style={{width:"10%"}} />
            <col style={{width:"20%"}} />
            <col style={{width:"10%"}} />
          </colgroup>
          <thead>
            <tr>
              <th className="board-list"><input type="checkbox" id="deleteItems" onChange={(e)=>onCheckedAll(e)}/></th>
              <th>번호</th>
              <th>등록일자</th>
              <th>아이디</th>
              <th>작성자</th>
              <th>소속</th>
              <th>직위</th>
              <th>업무요약</th>
              <th>상세</th>
            </tr>
          </thead>
          <tbody>
            {varStaffReportLists?.length === 0? 
              <tr>
                <td colSpan={9}>등록된 업무일지내역이 없습니다.</td>
              </tr>
            :
            varStaffReportLists.map((reports, i) => (
              <tr key={'reports_'+reports.sr_idx}>
                <td className="board-list">
                  <input type="checkbox" className={"del-item"} id={"deleteItem_" + reports.sr_idx} onChange={(e)=>onCheckedElement(e,reports.sr_idx)}/>
                </td>
                <td>{varMaxNumPage - i}</td>
                <td className="ellipsis">{ChangeDateStringOnlyDate(reports.sr_date)}</td>
                <td className="ellipsis">{reports.mem_id}</td>
                <td className="ellipsis">{reports.mem_name}</td>
                <td className="ellipsis">{reports.vd_name}</td>
                <td className="ellipsis">{reports.vp_name}</td>
                <td className="ellipsis limit-text">{unescapeHtml(reports.sr_summary)}</td>
                <td className="ellipsis"><Link to={`/Admin/StaffReportDetail/${reports.sr_idx}`} style={{width:"70px"}} className="btn line black">상세</Link></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default StaffReportSearchResult;